<style scoped lang="scss">
.tooltip-inner {
  max-width: 250px !important;
  width: 250px !important;
}
@media (min-width: 801px) {
  .tooltip-inner {
    max-width: 500px !important;
    width: 500px !important;
  }
}
</style>

<template>
  <td>
    <button
      v-tooltip:left="fullPostback"
      class="btn btn-primary fullPostbackTooltip"
    >
      Link
    </button>
  </td>
</template>

<script lang="babel">
export default {
  props: ['content'],
  computed: {
    fullPostback() {
      return this.content;
    },
  },
};
</script>
